var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalSalesInvoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333984,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#DEFFE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.334 18C26.334 13.5817 22.7522 10 18.334 10C13.9157 10 10.334 13.5817 10.334 18C10.334 22.4182 13.9157 26 18.334 26C22.7522 26 26.334 22.4182 26.334 18Z",
    fill: "#008B1F",
    stroke: "#008B1F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1348 18.3996L17.1348 20.3996L21.5348 15.5996",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSalesInvoiceIcon);
export default __webpack_public_path__ + "static/media/total_sales_invoice_icon.dbd4a737333946624a1f29caeae21350.svg";
export { ForwardRef as ReactComponent };